export const ReflectionLikeOptionEnum = {
    Like: 1,
    DisLike: 2
}